'use client';

import React__default, { useRef, useState } from 'react';
import { WarpBody } from '../index.css.js';
import { DEFAULT_ALLOW_EXT, DEFAULT_ALLOW_FILES_EXT, DEFAULT_LIMIT_FILE_SIZE, DEFAULT_1MB_SIZE, DEFAULT_1KB_SIZE } from '../constants.js';
import { isDesktop } from '../../Utils/helpers.js';
import { IconUploadButton } from '../images.js';
import Button from '../../Button/index.js';
import { useResumeModal } from '../context/useResumeModal.js';
import { ResponseMsg } from '../../DragDropResumeUpload/styles.css.js';
import { colors } from '../../Colors/index.js';

var AttachCV = function (_a) {
    var uploadErrorMessage = _a.uploadErrorMessage, doUploadFile = _a.doUploadFile;
    var _b = useResumeModal(), t = _b.t, setUploadFile = _b.setUploadFile, uploadFile = _b.uploadFile, isUploading = _b.isUploading, setIsUploading = _b.setIsUploading;
    var inputFileRef = useRef(null);
    var isMobile = !isDesktop();
    var _c = useState(false), isShowUploadFileError = _c[0], setShowUploadError = _c[1];
    var _d = useState(false), isDragOver = _d[0], setDragOver = _d[1];
    // upload file
    var checkUploadFile = function (file) {
        var uploadFileInfo = file;
        // check file extensions
        if (!DEFAULT_ALLOW_FILES_EXT.includes(uploadFileInfo.type)) {
            // show error file type doesn't support
            setShowUploadError(true);
            setUploadFile(undefined);
            return;
        }
        // check file size
        if (uploadFileInfo.size > DEFAULT_LIMIT_FILE_SIZE) {
            // File is over 5MB
            setShowUploadError(true);
            setUploadFile(undefined);
            return;
        }
        // do upload file and move to next tab
        doUploadFile(uploadFileInfo);
    };
    var handleOnFileChange = function (e) {
        if (e.target.files !== null && e.target.files.length > 0) {
            setShowUploadError(false);
            checkUploadFile(e.target.files[0]);
        }
    };
    var handleOnClickCancelUpload = function () {
        if (!isUploading) {
            return;
        }
        // cancel
        setIsUploading(false);
        setUploadFile(undefined);
        if (inputFileRef.current) {
            inputFileRef.current.files = null;
        }
    };
    var handleOnClickOpenFile = function () {
        if (isUploading) {
            return;
        }
        if (inputFileRef !== null && inputFileRef.current !== null) {
            inputFileRef.current.click();
        }
    };
    var formatFileSize = function (value) {
        var checkSize = DEFAULT_1KB_SIZE;
        var sizeText = 'KB';
        if (value >= DEFAULT_1MB_SIZE) {
            checkSize = DEFAULT_1MB_SIZE;
            sizeText = 'MB';
        }
        var formattedValue = value / checkSize;
        return "<b>".concat(formattedValue.toFixed(2), " ").concat(sizeText, "</b>");
    };
    var handleOnDragEnter = function (e) {
        e.preventDefault();
        setDragOver(true);
    };
    var handleOnDragLeave = function (e) {
        e.preventDefault();
        setDragOver(false);
    };
    var handleOnDragOver = function (e) {
        e.preventDefault();
    };
    var handleOnDragEnd = function (e) {
        e.preventDefault();
    };
    var handleOnDrop = function (e) {
        e.stopPropagation();
        e.preventDefault();
        setDragOver(false);
        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            e.dataTransfer.clearData();
            checkUploadFile(e.dataTransfer.files[0]);
        }
    };
    return (React__default.createElement(WarpBody.UploadCV, { onClick: handleOnClickOpenFile, onDragEnter: handleOnDragEnter, onDragLeave: handleOnDragLeave, onDragOver: handleOnDragOver, onDragEnd: handleOnDragEnd, onDrop: handleOnDrop },
        React__default.createElement("input", { type: 'file', accept: DEFAULT_ALLOW_EXT, style: { visibility: 'hidden' }, ref: inputFileRef, onChange: handleOnFileChange }),
        React__default.createElement(WarpBody.UploadSection, { isMobile: isMobile, isDragOver: isDragOver }, uploadFile !== undefined && uploadFile.name !== '' ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(WarpBody.SubTitle, { className: 'fileName' }, uploadFile.name),
            React__default.createElement(WarpBody.SubTitle, { className: 'fileSize', dangerouslySetInnerHTML: { __html: formatFileSize(uploadFile.size) } }),
            React__default.createElement(WarpBody.SubTitle, { className: 'changeFile', onClick: handleOnClickCancelUpload }, isUploading ? t('Hủy tải tập tin') : t('Đổi tập tin')),
            uploadErrorMessage !== '' ? (React__default.createElement(ResponseMsg, { variant: 'p', name: 'body', size: 'small', isPlaceholder: true, color: colors.error[40] }, uploadErrorMessage)) : null)) : (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(IconUploadButton, null),
            React__default.createElement(WarpBody.Title, null, t('Kéo hồ sơ của bạn vào đây')),
            React__default.createElement(WarpBody.SubTitle, null, t('Hoặc bạn có thể')),
            React__default.createElement(Button, { size: 'xs', type: 'primary' }, t('Chọn hồ sơ từ máy bạn')),
            React__default.createElement(WarpBody.Description, { dangerouslySetInnerHTML: {
                    __html: t('Hỗ trợ định dạng .doc, .docx, pdf có kích thước dưới 5120KB')
                } }),
            isShowUploadFileError && (React__default.createElement(WarpBody.Description, { className: 'error', dangerouslySetInnerHTML: {
                    __html: t('Vui lòng chọn tập tin đính kèm với định dạng .doc, .docx, .pdf nhỏ hơn 5120KB.')
                } })))))));
};

export { AttachCV, AttachCV as default };
//# sourceMappingURL=AttachCV.js.map
